import React, { FC } from "react";
import { DividerProps } from "@mui/material";
import { StyledDivider } from "./styled";

export const Divider: FC<DividerProps> = ({ ...props }) => {
  return <StyledDivider {...props} />;
};
